export default {
  // Common
  common: {
    save: 'சேமி',
    cancel: 'ரத்து',
    delete: 'நீக்கு',
    edit: 'திருத்து',
    view: 'பார்வை',
    add: 'சேர்',
    search: 'தேடு',
    filter: 'வடிகட்டு',
    loading: 'ஏற்றுகிறது...',
    error: 'பிழை',
    success: 'வெற்றி',
    confirm: 'உறுதிப்படுத்து',
    yes: 'ஆம்',
    no: 'இல்லை',
    close: 'மூடு',
    back: 'பின்',
    next: 'அடுத்து',
    previous: 'முந்தைய',
    submit: 'சமர்ப்பி',
    reset: 'மீட்டமை',
    clear: 'அழி',
    select: 'தேர்வு செய்',
    choose: 'தேர்ந்தெடு',
    upload: 'பதிவேற்று',
    download: 'பதிவிறக்கு',
    export: 'ஏற்றுமதி',
    import: 'இறக்குமதி',
    refresh: 'புதுப்பி',
    update: 'புதுப்பி',
    create: 'உருவாக்கு',
    remove: 'அகற்று',
    actions: 'செயல்கள்',
    status: 'நிலை',
    active: 'செயல்பாட்டில்',
    inactive: 'செயலற்ற',
    pending: 'நிலுவை',
    completed: 'முடிந்தது',
    total: 'மொத்தம்',
    name: 'பெயர்',
    email: 'மின்னஞ்சல்',
    phone: 'தொலைபேசி',
    address: 'முகவரி',
    date: 'தேதி',
    time: 'நேரம்',
    amount: 'தொகை',
    price: 'விலை',
    quantity: 'அளவு',
    description: 'விளக்கம்',
    notes: 'குறிப்புகள்'
  },

  // Navigation
  nav: {
    dashboard: 'டாஷ்போர்ட்',
    members: 'உறுப்பினர்கள்',
    membershipPlans: 'உறுப்பினர் திட்டங்கள்',
    payments: 'பணம் செலுத்துதல்',
    attendance: 'வருகை',
    reports: 'அறிக்கைகள்',
    trainersPlans: 'பயிற்சியாளர்கள் & திட்டங்கள்',
    gymProfile: 'ஜிம் விவரக்குறிப்பு',
    settings: 'அமைப்புகள்',
    logout: 'வெளியேறு'
  },

  // Dashboard
  dashboard: {
    title: 'டாஷ்போர்ட்',
    welcomeBack: 'மீண்டும் வரவேற்கிறோம்',
    totalMembers: 'மொத்த உறுப்பினர்கள்',
    activeMembers: 'செயல்படும் உறுப்பினர்கள்',
    monthlyRevenue: 'மாதாந்திர வருவாய்',
    pendingPayments: 'நிலுவையில் உள்ள பணம்',
    recentMembers: 'சமீபத்திய உறுப்பினர்கள்',
    recentPayments: 'சமீபத்திய பணம் செலுத்துதல்',
    monthlyTrends: 'மாதாந்திர போக்குகள்',
    quickStats: 'விரைவு புள்ளிவிவரங்கள்',
    viewAll: 'அனைத்தையும் பார்க்க',
    noData: 'தரவு கிடைக்கவில்லை',
    revenue: 'வருவாய்',
    growth: 'வளர்ச்சி',
    thisMonth: 'இந்த மாதம்',
    lastMonth: 'கடந்த மாதம்'
  },

  // Members
  members: {
    title: 'உறுப்பினர்கள்',
    addMember: 'உறுப்பினர் சேர்',
    memberList: 'உறுப்பினர் பட்டியல்',
    memberDetails: 'உறுப்பினர் விவரங்கள்',
    editMember: 'உறுப்பினரை திருத்து',
    deleteMember: 'உறுப்பினரை நீக்கு',
    memberName: 'உறுப்பினர் பெயர்',
    membershipPlan: 'உறுப்பினர் திட்டம்',
    joinDate: 'சேர்ந்த தேதி',
    expiryDate: 'காலாவதி தேதி',
    contactInfo: 'தொடர்பு தகவல்',
    emergencyContact: 'அவசர தொடர்பு',
    medicalInfo: 'மருத்துவ தகவல்',
    paymentHistory: 'பணம் செலுத்திய வரலாறு',
    attendanceHistory: 'வருகை வரலாறு',
    membershipStatus: 'உறுப்பினர் நிலை',
    renewMembership: 'உறுப்பினரை புதுப்பி',
    suspendMember: 'உறுப்பினரை நிறுத்து',
    searchMembers: 'உறுப்பினர்களை தேடு...',
    filterByPlan: 'திட்டத்தின் அடிப்படையில் வடிகட்டு',
    filterByStatus: 'நிலையின் அடிப்படையில் வடிகட்டு',
    noMembersFound: 'உறுப்பினர்கள் கிடைக்கவில்லை',
    totalMembers: 'மொத்த உறுப்பினர்கள்',
    newMembersToday: 'இன்றைய புதிய உறுப்பினர்கள்',
    expiringThisMonth: 'இந்த மாதம் காலாவதியாகும்'
  },

  // Gym Profile
  gymProfile: {
    title: 'ஜிம் விவரக்குறிப்பு',
    subtitle: 'உங்கள் ஜிமின் பிராண்டிங் மற்றும் விவரக்குறிப்பு தகவலை நிர்வகிக்கவும்',
    gymInfo: 'ஜிம் தகவல்',
    gymName: 'ஜிம் பெயர்',
    gymId: 'ஜிம் ஐடி',
    gymLogo: 'ஜிம் லோகோ',
    currentLogo: 'தற்போதைய லோகோ',
    uploadNewLogo: 'புதிய லோகோ பதிவேற்று',
    removeLogo: 'தற்போதைய லோகோவை அகற்று',
    logoRequirements: 'தேவைகள்',
    logoUsage: 'லோகோ பயன்பாடு',
    logoAppears: 'உங்கள் லோகோ தோன்றும் இடங்கள்:',
    bestPractices: 'சிறந்த நடைமுறைகள்:',
    currencySettings: 'நாணய அமைப்புகள்',
    currentCurrency: 'தற்போதைய நாணயம்',
    selectCurrency: 'புதிய நாணயம் தேர்ந்தெடுக்கவும்',
    chooseCurrency: 'நாணயம் தேர்ந்தெடுக்கவும்...',
    languageSettings: 'மொழி அமைப்புகள்',
    currentLanguage: 'தற்போதைய மொழி',
    selectLanguage: 'புதிய மொழி தேர்ந்தெடுக்கவும்',
    chooseLanguage: 'மொழி தேர்ந்தெடுக்கவும்...',
    contactSupport: 'ஜிம் பெயர், முகவரி அல்லது தொலைபேசி எண்ணை புதுப்பிக்க, ஆதரவை தொடர்பு கொள்ளவும்.',
    currencyNote: 'உங்கள் நாணயத்தை மாற்றுவது உங்கள் ஜிமில் உள்ள அனைத்து பண காட்சிகளையும் பாதிக்கும். இந்த மாற்றம் உங்கள் ஜிமை மட்டுமே பாதிக்கும் மற்றும் மற்ற ஜிம்களை பாதிக்காது.',
    languageNote: 'உங்கள் மொழியை மாற்றுவது உங்கள் ஜிம் போர்ட்டலில் உள்ள அனைத்து உரை காட்சிகளையும் பாதிக்கும். இந்த மாற்றம் உங்கள் ஜிமை மட்டுமே பாதிக்கும் மற்றும் மற்ற ஜிம்களை பாதிக்காது.'
  },

  // Messages
  messages: {
    memberAdded: 'உறுப்பினர் வெற்றிகரமாக சேர்க்கப்பட்டார்!',
    memberUpdated: 'உறுப்பினர் வெற்றிகரமாக புதுப்பிக்கப்பட்டார்!',
    memberDeleted: 'உறுப்பினர் வெற்றிகரமாக நீக்கப்பட்டார்!',
    profileUpdated: 'விவரக்குறிப்பு வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    logoUploaded: 'லோகோ வெற்றிகரமாக பதிவேற்றப்பட்டது!',
    logoRemoved: 'லோகோ வெற்றிகரமாக அகற்றப்பட்டது!',
    currencyUpdated: 'நாணயம் வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    languageUpdated: 'மொழி வெற்றிகரமாக புதுப்பிக்கப்பட்டது!',
    settingsSaved: 'அமைப்புகள் வெற்றிகரமாக சேமிக்கப்பட்டன!',
    operationFailed: 'செயல்பாடு தோல்வியடைந்தது. மீண்டும் முயற்சிக்கவும்.',
    networkError: 'நெட்வொர்க் பிழை. உங்கள் இணைப்பை சரிபார்க்கவும்.',
    confirmDelete: 'இந்த உருப்படியை நீக்க விரும்புகிறீர்களா?',
    confirmLogout: 'வெளியேற விரும்புகிறீர்களா?'
  }
};